import { SxProps } from '@mui/material'

import theme from '../../styles/themes/default.theme'

const styles = {
  container: {
    width: '100%'
  } as SxProps,

  searchCard: {
    mb: 3,
    borderRadius: theme.shape.borderRadius / 4
  } as SxProps,

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    py: 2
  } as SxProps,

  skeletonContainer: {
    py: 1,
    width: '100%'
  } as SxProps,

  locationsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '100%'
  } as SxProps,

  sectionTitle: {
    fontSize: '20px',
    fontWeight: 500,
    color: 'text.primary',
    textAlign: 'left',
    marginBottom: 1
  } as SxProps
}

export default styles
